import styled from "styled-components";
import { Color } from "config/colors";

export const IconsContainer = styled.div`
  display: flex;
  flex-direction: row;
  color: blue;
  grid-column: 5;
  gap: 12px;
  align-items: center;
`;

type IconCircularContainerProps = {
  isAccept?: boolean;
  isDisabled?: boolean;
  isBig?: boolean;
  backgroundColor?: Color;
  isSmall?: boolean;
  isMedium?: boolean;
};

export const IconCircularContainer = styled.div<IconCircularContainerProps>`
  background-color: ${(props) =>
    props.isAccept
      ? Color.LighterPositive
      : props.backgroundColor
      ? props.backgroundColor
      : Color.LighterDestructive};
  width: ${(props) =>
    props.isBig
      ? "48px"
      : props.isSmall
      ? "24px"
      : props.isMedium
      ? "40px"
      : "32px"};
  height: ${(props) =>
    props.isBig
      ? "48px"
      : props.isSmall
      ? "24px"
      : props.isMedium
      ? "40px"
      : "32px"};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition:
    box-shadow 0.2s ease-in-out,
    transform 0.2s;
  box-shadow:
    0 2px 4px rgba(0, 0, 0, 0.1),
    0 1px 2px rgba(0, 0, 0, 0.08);

  ${(props) =>
    props.isDisabled &&
    `
    opacity: 0.2;
  `}

  &:hover {
    ${(props) =>
      !props.isDisabled &&
      `
      transform: scale(1.1);
      box-shadow: 0 4px 8px rgba(0, 0, 0, 0.15), 0 2px 4px rgba(0, 0, 0, 0.1);
      opacity: 1;
    `}
  }

  &:active {
    ${(props) =>
      !props.isDisabled &&
      `
      transform: scale(0.95);
    `}
  }
`;
